var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_Q2",
    "data-name": "icons Q2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.787,
    height: 29.677,
    viewBox: "0 0 27.787 29.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M31.37,20.556l-2.223-2.167a3.008,3.008,0,0,1-.834-1.964V12.159C28.314,6.673,24.562,2,17.893,2S7.473,6.537,7.473,12.159V16.9a1.738,1.738,0,0,1-.486,1.151l-2.57,2.506A1.338,1.338,0,0,0,4,21.5V26.38a1.372,1.372,0,0,0,1.389,1.354H13.1a4.885,4.885,0,0,0,9.586,0H30.4a1.372,1.372,0,0,0,1.389-1.354V21.5A1.338,1.338,0,0,0,31.37,20.556Zm-2.362,4.47H6.779V22.114l2.153-2.167a4.281,4.281,0,0,0,1.32-3.048V12.159c0-3.589,2.015-7.45,7.641-7.45s7.641,4,7.641,7.45v4.267a5.747,5.747,0,0,0,1.6,3.86l1.876,1.829Z",
    transform: "translate(-4 -2)",
    fill: "#cbc3d6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.86fc6805aa9e1f9a5121462678b3eb25.svg";
export { ForwardRef as ReactComponent };